import {FreeDeliverySection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/basket_mov.types';
import {AddItemResponseStatus_Success_Section} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/add_item_status.types';
import {GetBasketRecommendationsResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/recommendations/service.types';
import {COLORS, Flyout} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';
import {AddToBasketSuccessSections} from '../../AddToBasketSuccessSections/AddToBasketSuccessSections';
import {PromotionInvalidSection} from '../../AddToBasketSuccessSections/PromotionInvalidSection';
import {BasketUrgencyHint} from '../../BasketUrgencyHint/BasketUrgencyHint';
import {getBasketUrgencyFromSections} from '../../BasketUrgencyHint/utils/getBasketUrgencyFromSections';
import {getPromotionInvalidFromSections} from '../../BasketUrgencyHint/utils/getPromotionInvalidSection';
import {FreeDeliverySectionView} from '../../FreeDeliverySectionView/FreeDeliverySectionView';
import {AddToBasketSuccessRecosView} from '../AddToBasketSuccessRecos/AddToBasketSuccessRecosView';

interface AddToBasketSuccessFlyoutContentProps
  extends GetBasketRecommendationsResponse {
  trackOriginClick: VoidFunction;
  ctas: React.ReactNode;
  freeDeliverySection?: FreeDeliverySection;
  statusSuccessSections: AddItemResponseStatus_Success_Section[];
}

export const AddToBasketSuccessFlyoutContentView: React.FC<
  AddToBasketSuccessFlyoutContentProps
> = ({
  ctas,
  freeDeliverySection,
  recommendation,
  trackOriginClick,
  statusSuccessSections,
}) => {
  const basketUrgency = getBasketUrgencyFromSections(statusSuccessSections);
  const promotionInvalidSection = getPromotionInvalidFromSections(
    statusSuccessSections,
  );

  return (
    <>
      {promotionInvalidSection && (
        <PromotionInvalidSection promotionInvalid={promotionInvalidSection} />
      )}

      <StyledFreeDeliverySectionView
        freeDeliverySection={freeDeliverySection}
        ProgressMoreInfoLayoutComponent={Flyout}
      />
      <BasketUrgencyHintWrapper>
        <BasketUrgencyHint basketUrgency={basketUrgency} />
      </BasketUrgencyHintWrapper>
      {ctas}
      <AddToBasketSuccessSections
        statusSuccessSections={statusSuccessSections}
      />
      <AddToBasketSuccessRecosView
        trackOriginClick={trackOriginClick}
        recommendation={recommendation}
      />
    </>
  );
};

const StyledFreeDeliverySectionView = styled(FreeDeliverySectionView)`
  ${props =>
    props.freeDeliverySection?.type?.$case === 'infoMessage'
      ? css`
          margin-inline: 1rem;
        `
      : css`
          padding: 1.25rem;
          border-bottom: 1px solid ${COLORS.Grey3};
        `}
`;

const BasketUrgencyHintWrapper = styled.div`
  margin-top: 16px;
`;
